import React, { useState, useRef, useEffect, useMemo } from "react";
import { Collapse, Card, CardBody, Spinner } from "reactstrap";
import {
  checkWidgetAdminOrNot,
  scaleTypeCode,
} from "../../../../utils/Constants";
import { useReactToPrint } from "react-to-print";
import "./ledgerPrintStyles.scss";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { NepaliDatePicker } from "nepali-calander";
import CustomModal from "../../../common/CustomModal";
import moment from "moment";
import ModalWindow from "../../../UI/ModalWindow";
import { Switch } from "@material-ui/core";

const ReportGeneratorUI = (props) => {
  const [reportSetupData, setReportSetupData] = useState("");
  const [yrLvl, setYrLvl] = useState(null);
  const [clssLvl, setClssLvl] = useState(null);
  const [assessId, setAssessId] = useState(props?.assessmentName);
  const [isPercent, SetIsPercent] = useState(false);

  const [sectionName, setSectionName] = useState("");
  const componentRef = useRef();
  const [calendarMode, setCalendarMode] = useState(
    localStorage.getItem("calendar-mode") || "bs",
  );
  const [publishDate, setPublishDate] = useState("");
  const [selectedPublishedDate, setSelectedPublishedDate] = useState("");

  const [isAggregation, setIsAggregation] = useState(false);
  const [configModal, setConfigModal] = useState(false);
  const [reportSubmitType, setReportSubmitType] = useState(null);

  const printFunction = useReactToPrint({
    content: () => componentRef.current,
    orientation: "landscape",
    removeAfterPrint: true,
    documentTitle: `report_ledger_${yrLvl?.name}_${sectionName}`,
    pageStyle: "a4",
    layout: "A4",
  });

  const hasAggegation = useMemo(() => {
    if (props?.assessmentList?.length === 0) return false;

    return props.assessmentList?.find(
      (item) => String(item?.id) === props.assessmentName,
    )?.hasAggregationConfig;
  }, [props?.assessmentList, props?.assessmentName]);

  useEffect(() => {
    let yearLvl = props?.yearLevels?.filter(
      (item) => item.id === props.yearLevelId,
    )[0];
    setYrLvl(yearLvl);
    let classLvl = yearLvl?.classroomYearLevelRecruitmentRoom?.filter(
      (item) => item.id === props.classroomId,
    )[0];
    setClssLvl(classLvl);
    let className = classLvl?.name;

    setSectionName(className);
  }, [props?.yearLevelId]);

  // useEffect(() => {
  //   if (props.studentsLists && props.studentsLists?.length > 0) {
  //     const hasTotalObtainedPercentage = props.studentsLists.some(student =>
  //       student?.values && student?.values?.totalobtainedPercentage
  //     );
  //     SetIsPercent(hasTotalObtainedPercentage)
  //   }
  // }, [props.studentsLists]);
  useEffect(() => {
    let date =
      calendarMode === "bs" ? publishDate?.bs?.date : publishDate?.ad?.date;
    if (date) {
      setSelectedPublishedDate(date);
    }
  }, [publishDate, calendarMode]);

  const percentToggler = () => {
    SetIsPercent(!isPercent);
  };

  const publishButtonClicked = () => {};

  return (
    <>
      <Collapse isOpen={props.isClassroomOpen}>
        <Card>
          <CardBody>
            <>
              {props.showSpinner ? (
                <div className="fullWindow-Spinner">
                  <div>
                    <Spinner color="white"></Spinner>
                  </div>
                  <div style={{ fontSize: "16px", marginTop: "15px" }}>
                    Please Wait. Processing...
                  </div>
                </div>
              ) : null}
              <div className="tt-group-header text-center">
                <div className="row">
                  <div className="col-md-3">
                    <select
                      className="form-control"
                      name="assessmentName"
                      onChange={(e) =>
                        props.handleAssessmentChange(e, props.yearLevelId)
                      }
                      value={props.assessmentName}
                    >
                      <option value="" disabled>
                        Select Assessment
                      </option>
                      {props.assessmentList.map((assessment, idx) => (
                        <option value={assessment.id}>
                          {assessment.assessmentName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <select
                      className="form-control"
                      name="reportSetupId"
                      value={props.reportSetupId}
                      onChange={(e) => {
                        props.universalHandleChange(e);
                        let filtredTemplate = props.templateSetup.filter(
                          (template) => template.name === e.target.value,
                        );
                        if (filtredTemplate.length > 0) {
                          setReportSetupData(filtredTemplate[0]);
                        } else {
                          setReportSetupData({});
                        }
                      }}
                      // disabled={!props.assessmentName}
                    >
                      <option value={""} disabled>
                        Select report setup
                      </option>
                      {props.reportSetups.length > 0
                        ? props.reportSetups.map((report, reportIdx) => (
                            <option value={report.id} key={reportIdx}>
                              {report.name}
                            </option>
                          ))
                        : "No setups"}
                      <option value={""} disabled>
                        Select template without watermark
                      </option>
                      {props.templateSetup.filter((item) => !item.hasWatermark)
                        .length > 0
                        ? props.templateSetup
                            .filter((item) => !item.hasWatermark)
                            .map((template, templateIdx) => (
                              <option value={template.name} key={templateIdx}>
                                {template.name}
                              </option>
                            ))
                        : "No setups"}
                      <option value={""} disabled>
                        Select template with watermark
                      </option>
                      {props.templateSetup.filter((item) => item.hasWatermark)
                        .length > 0
                        ? props.templateSetup
                            .filter((item) => item.hasWatermark)
                            .map((template, templateIdx) => (
                              <option value={template.name} key={templateIdx}>
                                {template.name}
                              </option>
                            ))
                        : "No setups"}
                    </select>
                  </div>
                  <div className="col-md-2 mt-1">
                    {props.reportSetups.length > 0 ? (
                      ""
                    ) : props.reportSetups.length === 0 &&
                      props.assessmentName ? (
                      <p style={{ marginLeft: "2%", display: "inline" }}>
                        (No Setups)
                      </p>
                    ) : (
                      <p style={{ marginLeft: "2%", display: "inline" }}>
                        (Select assessment first)
                      </p>
                    )}
                  </div>
                  <div
                    className="col-md-4"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    <button
                      className="tt-button tt-button-primary"
                      onClick={(e) => printFunction()}
                      disabled={
                        // !props.assessmentName ||
                        !props.assessmentName
                      }
                    >
                      Print ledger
                    </button>

                    <button
                      className="tt-button tt-button-primary"
                      onClick={(e) => {
                        // props.handleGenerateReport(
                        //   props.yearLevelId,
                        //   props.classroomId,
                        //   selectedPublishedDate,
                        // )
                        setConfigModal((prev) => !prev);
                        setReportSubmitType("generate");
                      }}
                      disabled={
                        // !props.assessmentName ||
                        !props.reportSetupId
                      }
                    >
                      Generate
                    </button>
                    {checkWidgetAdminOrNot(props.name) === true ||
                    (props.loggedIdUserRecruitmentId
                      ? parseInt(props.loggedIdUserRecruitmentId.id) ===
                        parseInt(props.recruitmentId)
                      : null) ? (
                      <button
                        className="tt-button tt-button-primary"
                        onClick={(e) => {
                          setConfigModal((prev) => !prev);
                          setReportSubmitType("publish");
                        }}
                        disabled={
                          // !props.assessmentName ||
                          !props.reportSetupId
                        }
                      >
                        Publish
                      </button>
                    ) : null}
                    {/* </a> */}
                  </div>
                </div>
              </div>

              {reportSetupData?.description && props?.reportSetupId ? (
                <div
                  style={{
                    padding: "1rem",
                    fontSize: "1rem",
                    color: "#f09090",
                  }}
                >
                  Note : {reportSetupData?.description}
                </div>
              ) : null}

              {props?.assessmentName ? (
                <>
                  {props?.assessmentDataLoader ? (
                    <>
                      <div className="text-center">
                        <Spinner color="primary"></Spinner>
                        <br></br>Loading Data...
                      </div>
                    </>
                  ) : (
                    <>
                      {props?.subjectAllData?.length > 0 ? (
                        <>
                          <div
                            className="landscape"
                            style={{ overflowX: "scroll", overflowY: "scroll" }}
                            id="printRoutine"
                            ref={componentRef}
                          >
                            <div className="print-header my-2 text-center">
                              <p className="mb-0">
                                {yrLvl?.name}, {sectionName}
                              </p>
                              {/* <br/> */}
                              <p className="mb-0">
                                {
                                  clssLvl?.assessments?.filter(
                                    (item) =>
                                      item?.id ===
                                      parseInt(props?.assessmentName),
                                  )[0]?.assessmentName
                                }
                              </p>
                              {/* <br/> */}
                              <p className="mb-0">Mark Ledger</p>
                            </div>
                            <table className="table table-bordered table-striped report-ledger">
                              <thead>
                                <tr style={{ color: "white" }}>
                                  <th
                                    className="print-exclude"
                                    rowSpan="2"
                                    width="50px"
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={props.allStudentChecked}
                                      onClick={
                                        props.handleSelectAllCheckBoxClick
                                      }
                                    />
                                  </th>
                                  <th rowSpan="2">S.No.</th>
                                  <th rowSpan="2">Student Name</th>
                                  <th rowSpan="2">Symbol No.</th>
                                  {props?.subjectAllDatas?.map((item) => (
                                    <th key={item.id} colSpan="3">
                                      {item.subjectName}
                                    </th>
                                  ))}
                                  <th colSpan={isPercent ? `5` : `3`}>
                                    <div className="d-flex align-items-center justify-content-center flex-column">
                                      <p className="mb-0">Result Information</p>
                                      {/* added a switch for toggle between percent and gpa values */}
                                      <div
                                        className="d-flex align-items-center justify-content-center mt-2"
                                        id="hideToggle"
                                      >
                                        <div className="assessment_toggle">
                                          <div>
                                            {!!!isPercent ? (
                                              "GPA"
                                            ) : (
                                              <strong>GPA</strong>
                                            )}
                                          </div>

                                          <label className="switch mx-2 mb-2">
                                            <input
                                              type="checkbox"
                                              checked={isPercent}
                                              onChange={(e) => {
                                                percentToggler();
                                              }}
                                            />
                                            <span className="slider round" />
                                          </label>
                                          <div>
                                            {!!!isPercent ? (
                                              <strong>Percentage</strong>
                                            ) : (
                                              "Percentage"
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr style={{ color: "white" }}>
                                  {props?.subjectAllDatas.map((item) => (
                                    <>
                                      <th>TH</th>
                                      <th>PR</th>
                                      <th>Tot.</th>
                                    </>
                                  ))}
                                  <th>Total obtained</th>
                                  <th>Rank</th>
                                  {isPercent ? (
                                    <>
                                      <th>Percent</th>
                                      <th>Result</th>
                                      <th>Division</th>
                                    </>
                                  ) : (
                                    <>
                                      <th>GPA</th>
                                    </>
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                                {props.studentsLists.map((student, index) => {
                                  // function to get marks for a subject
                                  const getSubjectMarks = (subjectId) => {
                                    const studentSubject =
                                      student.subjects.find(
                                        (sub) => sub.id === subjectId,
                                      );
                                    return (
                                      studentSubject?.studentSubjectAssessment ||
                                      {}
                                    );
                                  };
                                  const studentReportValues =
                                    props.reportValues?.filter(
                                      (item) => item.admissionId === student.id,
                                    )[0];

                                  return (
                                    <tr key={student.id}>
                                      <td
                                        className="print-exclude"
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          id={student.id}
                                          checked={student.checked}
                                          onClick={(e) =>
                                            props.handlSelectRowCheckBoxClick(
                                              e,
                                              student.people.id,
                                            )
                                          }
                                        />
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        {index + 1}
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        {student.people.name}
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        {student?.symbolNo || "-"}
                                      </td>

                                      {/* Map through subjects once per student */}
                                      {props.subjectAllDatas.map((subject) => {
                                        const marks = getSubjectMarks(
                                          subject.subjectId,
                                        );
                                        const theoryMark = marks.isTheoryAbsent
                                          ? "Ab"
                                          : (marks.theoryObtainedMarks ?? "-");
                                        const practicalMark =
                                          marks.isPracticalAbsent
                                            ? "Ab"
                                            : (marks.practicalObtainedMarks ??
                                              "-");
                                        const totalMark =
                                          marks.isTheoryAbsent ||
                                          marks.isPracticalAbsent
                                            ? "Ab"
                                            : (marks.obtainedMarks ?? "-");
                                        console.log(
                                          `${student?.people?.name} - ${subject?.name} : ${totalMark}`,
                                        );

                                        return (
                                          <React.Fragment key={subject.id}>
                                            {subject?.hasTheory ? (
                                              <td className="text-center">
                                                {theoryMark}
                                              </td>
                                            ) : (
                                              <td className="text-center">
                                                N/A
                                              </td>
                                            )}
                                            {subject?.hasPractical ? (
                                              <td className="text-center">
                                                {practicalMark}
                                              </td>
                                            ) : (
                                              <td className="text-center">
                                                N/A
                                              </td>
                                            )}
                                            <td className="text-center">
                                              {totalMark}
                                            </td>
                                          </React.Fragment>
                                        );
                                      })}
                                      <td style={{ textAlign: "center" }}>
                                        {studentReportValues?.values
                                          ?.obtainedMarks ?? "-"}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {studentReportValues?.values?.rank ??
                                          "-"}
                                      </td>
                                      {isPercent ? (
                                        <>
                                          <td style={{ textAlign: "center" }}>
                                            {Math.round(
                                              studentReportValues?.values
                                                ?.percent * 10,
                                            ) / 10 || "-"}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {studentReportValues?.values
                                              ?.result ?? "-"}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {studentReportValues?.values
                                              ?.division ?? "-"}
                                          </td>
                                        </>
                                      ) : (
                                        <>
                                          <td style={{ textAlign: "center" }}>
                                            {studentReportValues?.values
                                              ?.finalGrade ?? "-"}
                                          </td>
                                        </>
                                      )}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </>
                      ) : (
                        <>No data found</>
                      )}
                    </>
                  )}
                </>
              ) : (
                <></>
              )}
            </>
          </CardBody>
        </Card>
      </Collapse>

      <ModalWindow
        modal={configModal}
        toggleModal={() => {
          setConfigModal((prev) => !prev);
          setReportSubmitType(null);
          setPublishDate("");
        }}
        modalHeader={"Configure Report Settings"}
        modalBody={
          <div className="report-publish-date">
            <NepaliDatePicker
              styles={{ width: "100%" }}
              onDateSelect={(date) => {
                setPublishDate(date);
              }}
              showToggle={true}
              showNationalHoliday={false}
              calendarMode={calendarMode}
              onCalendarModeChange={(mode) => {
                setCalendarMode(mode);
              }}
              value={publishDate?.ad?.date}
              placeholder={"Select publish date"}
              disabled={
                // !props.assessmentName ||
                !props.reportSetupId
              }
            />

            {hasAggegation && (
              <div style={{ marginTop: "20px" }}>
                <label>Allow Aggregation</label>
                <Switch
                  checked={isAggregation}
                  onClick={(e) => setIsAggregation((prev) => !prev)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </div>
            )}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                gap: "8px",
                marginTop: "20px",
              }}
            >
              <button
                onClick={() => {
                  setConfigModal((prev) => !prev);
                  setReportSubmitType(null);
                  setPublishDate("");
                }}
                className="tt-button tt-button-primary"
              >
                Cancel
              </button>

              {reportSubmitType === "generate" ? (
                <button
                  className="tt-button tt-button-primary"
                  onClick={(e) => {
                    props.handleGenerateReport(
                      props.yearLevelId,
                      props.classroomId,
                      selectedPublishedDate,
                      isAggregation,
                    );
                    setConfigModal(false);
                    setReportSubmitType(null);
                    setPublishDate("");
                    setSelectedPublishedDate("");
                    setCalendarMode(localStorage.getItem("calendar-mode"));
                    setIsAggregation(false);
                  }}
                  disabled={
                    // !props.assessmentName ||
                    !props.reportSetupId
                  }
                >
                  Generate
                </button>
              ) : reportSubmitType === "publish" ? (
                <button
                  className="tt-button tt-button-primary"
                  onClick={(e) => {
                    props.handlePublishReport(
                      props.yearLevelId,
                      props.classroomId,
                      selectedPublishedDate,
                      isAggregation,
                    );
                    setConfigModal(false);
                    setReportSubmitType(null);
                    setPublishDate("");
                    setSelectedPublishedDate("");
                    setCalendarMode(localStorage.getItem("calendar-mode"));
                    setIsAggregation(false);
                  }}
                  disabled={
                    // !props.assessmentName ||
                    !props.reportSetupId
                  }
                >
                  Publish
                </button>
              ) : null}
            </div>
          </div>
        }
      />
    </>
  );
};

export default ReportGeneratorUI;
